import React from 'react';
import { I18n } from '@aws-amplify/core';

import * as S from './styles';

interface RiskBadgeProps {
	taskRPN: number;
}

export function RiskBadge({ taskRPN = 0 }: Readonly<RiskBadgeProps>) {
	return (
		<S.RiskBadgeContainer>
			<S.RiskBadgeContent>
				{I18n.get('RPN')}:{taskRPN}
			</S.RiskBadgeContent>
		</S.RiskBadgeContainer>
	);
}
